import React from "react";
import { Link } from 'react-router-dom';

function ItemCard2(props)
{
  return(
    <>
    <Link style={{ textDecoration: 'none', color: 'inherit' }} to = {{pathname:'/item', 
        state:{ itemSeller:props.seller, itemID:props.itemID, itemRating:props.rating }}}>
        <div className="card" style={{width: "16rem"}}>
            <img src={props.images} className="card-img-top" alt="..."  style={{width: '100%', height: '12vw', objectFit: 'cover'}}/>
            <div className="card-body w3-light-gray">
                <p className="card-title" style={{  lineHeight: '1.5em', height: '3em', overflow: 'hidden', fontSize:'14px'}}><b><i>{props.title}</i></b></p>
                <h3 className="card-text" style={{textAlign:'justify',color:'orange'}}>RS. {props.price}</h3>
            </div>
        </div>
    </Link>
    </>
    )
}
export default ItemCard2;